var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMySchedule1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00195 1.25V4.625",
    stroke: "#767676",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 1.25V4.625",
    stroke: "#767676",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93945 9.22656H21.0645",
    stroke: "#767676",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.252 24.875C20.7372 24.875 22.752 22.8603 22.752 20.375C22.752 17.8897 20.7372 15.875 18.252 15.875C15.7667 15.875 13.752 17.8897 13.752 20.375C13.752 22.8603 15.7667 24.875 18.252 24.875Z",
    stroke: "#767676",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9267 20.4316H16.5742",
    stroke: "#767676",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.251 18.7891V22.1528",
    stroke: "#767676",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.627 8.5625V17.405C20.8057 16.4712 19.602 15.875 18.252 15.875C15.7657 15.875 13.752 17.8887 13.752 20.375C13.752 21.2188 13.9882 22.0175 14.4045 22.6925C14.6407 23.0975 14.9444 23.4575 15.2932 23.75H7.00195C3.06445 23.75 1.37695 21.5 1.37695 18.125V8.5625C1.37695 5.1875 3.06445 2.9375 7.00195 2.9375H16.002C19.9395 2.9375 21.627 5.1875 21.627 8.5625Z",
    stroke: "#767676",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1393 13.7695H12.1494",
    stroke: "#767676",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33269 13.7695H7.34279",
    stroke: "#767676",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33269 18.4297H7.34279",
    stroke: "#767676",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySchedule1);
export default __webpack_public_path__ + "static/media/mySchedule1.e4f25b349c5507f730f44cd7fd90dc1b.svg";
export { ForwardRef as ReactComponent };